import { render } from "./yeqianfuwenben.vue?vue&type=template&id=4876cbd2&scoped=true"
import script from "./yeqianfuwenben.vue?vue&type=script&lang=js"
export * from "./yeqianfuwenben.vue?vue&type=script&lang=js"

import "./yeqianfuwenben.vue?vue&type=style&index=0&id=4876cbd2&scoped=true&lang=css"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4876cbd2"]])

export default __exports__